export default "__VITE_ASSET__47X5b9G9__"